<template>
  <b-modal
    scrollable
    centered
    cancel-disabled
    ok-disabled
    no-stacking
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
    ref="associateMaterialsModal"
  >
    <VHeader :modal-button="true" @close-modal="closeModal">
      <template #modal-title
        >Biological Materials Associated with Research Project</template
      >
    </VHeader>
    <BioProjectMaterials
      :group-nid="groupNid"
      :default-project-nid="defaultProjectNid"
      @close-modal="closeModal"
    />
  </b-modal>
</template>

<script>
import { useQueryString } from "@/composables/useQueryString";
import BioProjectMaterials from "./BioProjectMaterials.vue";
import VHeader from "../raft/VHeader.vue";

export default {
  name: "BioProjectMaterialsBModal",
  components: {
    BioProjectMaterials,
    VHeader,
  },
  methods: {
    closeModal() {
      this.$refs.associateMaterialsModal.hide();
      this.removeQueryString("modal");
      window.location.reload();
    },
  },
  props: {
    groupNid: { type: String, required: true },
    defaultProjectNid: { type: String, default: "" },
    isInBioMaterials: { type: Boolean, default: false },
  },
  mounted() {
    this.$refs.associateMaterialsModal.show();
  },
  setup() {
    const { removeQueryString, params } = useQueryString();
    return { removeQueryString, params };
  },
};
</script>
